"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInUrlBuilder = void 0;
var queryString = require("query-string");
var SignInUrlBuilder;
(function (SignInUrlBuilder) {
    var QueryKey;
    (function (QueryKey) {
        QueryKey["redirect"] = "redirect";
        QueryKey["error"] = "error";
        QueryKey["externalRedirect"] = "externalRedirect";
        QueryKey["site"] = "site";
        QueryKey["siteLuid"] = "siteLuid";
        QueryKey["target_site"] = "target_site";
        QueryKey["closePopupWhenDone"] = "closePopupWhenDone";
        QueryKey["passwordResetSuccess"] = "passwordResetSuccess";
        QueryKey["disableAppBanner"] = "disableAppBanner";
        QueryKey["deepLinkingDisabled"] = ":deepLinkingDisabled";
        QueryKey["client_type"] = "client_type";
        QueryKey["disableAutoSignin"] = "disableAutoSignin";
        QueryKey["auth"] = "auth";
        QueryKey["forceSitePick"] = "forceSitePick";
        QueryKey["isDefaultIdentityPoolLogin"] = "isDefaultIdentityPoolLogin";
        QueryKey["clientAppId"] = "clientAppId";
        // Used by SiteSaml to return the SAML response back to the requester instead of redirecting to the pod.
        QueryKey["sendResponseBackToRequester"] = "sendResponseBackToRequester";
        // Used by SiteSaml to determine if the scope is isolated to a single site.
        QueryKey["siteScopeEnforced"] = "siteScopeEnforced";
        // If true, will ensure the ForceAuthN=true is passed to SiteSaml, otherwise will be ignored and default server setting will be used.
        QueryKey["ensureForceAuthN"] = "ensureForceAuthN";
        QueryKey["authSetting"] = "authSetting";
        QueryKey["embedded"] = "embedded";
    })(QueryKey = SignInUrlBuilder.QueryKey || (SignInUrlBuilder.QueryKey = {}));
    function buildQuery(queryParams) {
        var query = Object.entries(queryParams).reduce(function (prevValue, currentValue) {
            if (typeof currentValue[1] === 'boolean') {
                return (prevValue ? prevValue + '&' : '') + currentValue[0] + '=' + (currentValue[1] ? 'yes' : 'no');
            }
            else if (currentValue[1]) {
                return (prevValue ? prevValue + '&' : '') + currentValue[0] + '=' + encodeURIComponent(currentValue[1]);
            }
            return prevValue;
        }, '');
        return query;
    }
    SignInUrlBuilder.buildQuery = buildQuery;
    function queryParamsFromQuery(query) {
        var params = queryString.parse(query);
        Object.keys(params).forEach(function (key) {
            var val = params[key];
            if (key === QueryKey.error) { // convert number types to `number`
                params[key] = +val;
            }
            else if ( // convert boolean types to `boolean`
            key === QueryKey.disableAutoSignin
                || key === QueryKey.passwordResetSuccess
                || key === QueryKey.disableAppBanner
                || key === QueryKey.deepLinkingDisabled
                || key === QueryKey.closePopupWhenDone
                || key === QueryKey.forceSitePick
                || key === QueryKey.isDefaultIdentityPoolLogin
                || key === QueryKey.embedded) {
                params[key] = BooleanQueryParamRegex.test(val);
            }
            else {
                params[key] = val;
            }
        });
        return params;
    }
    SignInUrlBuilder.queryParamsFromQuery = queryParamsFromQuery;
    // Taken from httpd.conf (.*(?:\:|\%3A)embed=(y|yes|t|true|1).*)
    var BooleanQueryParamRegex = /^[yt1]/i;
})(SignInUrlBuilder = exports.SignInUrlBuilder || (exports.SignInUrlBuilder = {}));
//# sourceMappingURL=SignInUrlBuilder.js.map